export const ineffectualSettingsFields = ["entityType", "type", "sortIndex", "id", "name", "parentId"] as const;

export const ineffectualSettingsFieldsSet: ReadonlySet<(typeof ineffectualSettingsFields)[number]> = new Set(
  ineffectualSettingsFields,
);
